"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_data__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "d44e7e70-bd01-40b4-96d3-07e9a2ffffdf",
    "data-name": "Data_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.34,124H144V84a16,16,0,0,0-16-16H96v56H81.66a4,4,0,0,0-2.83,6.83L120,172l41.17-41.17A4,4,0,0,0,158.34,124Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.67,68H48v40a16,16,0,0,0,16,16H96V68h14.34a4,4,0,0,0,2.83-6.83L72,20,30.85,61.17A4,4,0,0,0,33.67,68Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,66H33.67a3.93,3.93,0,0,1-3.84-3,4,4,0,0,0,3.84,5H48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,106v2a16,16,0,0,0,16,16H96v-2H64A16,16,0,0,1,48,106Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.36,66H96v2h14.34a4,4,0,0,0,3.84-5A3.93,3.93,0,0,1,110.36,66Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.17,128.83,120,170,78.83,128.83a3.91,3.91,0,0,1-1-1.8,3.88,3.88,0,0,0,1,3.8L120,172l41.17-41.17a3.88,3.88,0,0,0,1-3.8A3.91,3.91,0,0,1,161.17,128.83Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "04693196-eada-4179-8f7e-3e23935389f7",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "data-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "6ed03844-f21e-4e70-94bf-c11a8d05a50a",
    "data-name": "Data_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "6c96abd8-5062-49a4-b7c8-4b05a61e3928",
    "data-name": "Data_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#d44e7e70-bd01-40b4-96d3-07e9a2ffffdf"
  })));
}

var _default = ic_data__dark;
exports.default = _default;